import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import IAudio from "../engine/IAudio";

@injectable()
export default class ButtonSounds {

    protected audio: IAudio;

    constructor(
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: IAudio
    ) {
        this.audio = audio;

    }

    click() {

        // switch

        this.audio.playTrack("button_click");

    }

}